<template>
  <div>
    <app-timeline v-if="events.length > 0">
      <app-timeline-item
        v-for="(logItem, index) in events"
        :key="index"
        :title="logItem.message"
        :subtitle="logItem.reporter.full_name"
        :time="getTime(logItem.created_at)"
        :variant="getColor(logItem)"
      />
    </app-timeline>
    <h5 class="text-center my-2" v-else style="opacity: 0.6">
      لا يوجد أنشطة حتى الآن
    </h5>
  </div>
</template>

<script>
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
  },
  props: {
    events: {
      // type: Array,
      default: () => [],
    },
  },
  data: () => {
    return {
      colors: ["warning", "success", "success", "info", "danger"],
    };
  },
  methods: {
    getColor(item) {
      return item.action_type === "processing"
        ? "warning"
        : item.action_type === "authenticated"
        ? "success"
        : item.action_type === "unauthenticated"
        ? "danger"
        : "secondary";
    },
    getTime(time) {
      return this.$moment(time).locale("ar").fromNow();
    },
  },
};
</script>
